import { money } from "@/lib/format";

export const TONE = {
  ok: "border-emerald-200 bg-emerald-50 text-emerald-800",
  warn: "border-[color:var(--tt-warn-border)] bg-[color:var(--tt-warn-bg)] text-[color:var(--tt-warn-text)]",
};

export const SECTION_TONE = {
  action_overdue: "border-destructive/30 bg-destructive/5 text-destructive",
  due_today: TONE.warn,
  gone_quiet: TONE.warn,
  never_contacted:
    "border-[color:var(--tt-teal-line)] bg-[color:var(--tt-teal-mist)] text-[color:var(--tt-teal-deep)]",
};

/** Money note for a recap tile: once-off, monthly, or both. */
export const valueNote = (once, monthly) =>
  [once ? money(once) : "", monthly ? `${money(monthly)} p/m` : ""]
    .filter(Boolean)
    .join(" + ") || "nothing yet";

/**
 * Where the sending setup currently stands, resolved once.
 *
 * The four states are ordered worst-first: being switched off matters more
 * than using a test sender, which matters more than an unverified domain.
 * Returning the label and the tone together means the badge, its icon and the
 * setup box can never fall out of step with each other.
 */
export const senderState = ({ configured, testSender, domainPending }) => {
  if (!configured) return { label: "Switched off", healthy: false };
  if (testSender) return { label: "Test sender only", healthy: false };
  if (domainPending) return { label: "Domain not verified", healthy: false };
  return { label: "Sending", healthy: true };
};

/**
 * A switch that also needs a key before it can do anything: "off" beats
 * "on but unusable", which beats working.
 */
export const toggleState = ({ enabled, configured }) => {
  if (!enabled) return { label: "Switched off", healthy: false };
  if (!configured) return { label: "Ready, waiting on the key", healthy: false };
  return { label: "Sending", healthy: true };
};
